<template>
	<span
		class="status-badge"
		:style="{ backgroundColor: resolvedBackgroundColor }"
	>
		{{ normalizedStatus }}
	</span>
</template>

<script>
const STATUS_COLORS = {
	unverified: '#DDB341',
	pending: '#3182CE',
	verified: '#38A169',
	failed: '#E53E3E',
	stale: '#718096',
	draft: '#805AD5',
}

const VALID_STATUSES = Object.keys(STATUS_COLORS)

const UNVERIFIED_STATUS = 'unverified'

export default {
	computed: {
		normalizedStatus() {
			const status = String(
				this.status || UNVERIFIED_STATUS
			).toLowerCase()

			return VALID_STATUSES.includes(status) ? status : UNVERIFIED_STATUS
		},

		resolvedBackgroundColor() {
			if (this.backgroundColor) {
				return this.backgroundColor
			}

			return STATUS_COLORS[this.normalizedStatus]
		},
	},
	name: 'StatusBadge',

	props: {
		backgroundColor: {
			default: '',
			type: String,
		},

		status: {
			default: UNVERIFIED_STATUS,
			type: String,
		},
	},
}
</script>

<style lang="scss" scoped>
.status-badge {
	align-items: center;
	border: 1px solid #f7fafc;
	border-radius: 4px;
	color: #fff;
	display: inline-flex;
	font-family: 'Roboto', sans-serif;
	font-size: 12px;
	font-weight: 600;
	justify-content: center;
	line-height: 1;
	padding: 4px 6px;
	text-transform: capitalize;
	white-space: nowrap;
}
</style>
